export const taxKeys = {
  all: (storeId: string) => ['stores', storeId, 'tax-rates'] as const,
  list: (storeId: string) => [...taxKeys.all(storeId), 'list'] as const,
};
